import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { useTenant } from '../../hooks/useTenant';
import type { ChartsResponse, TimeRange } from '../types';
import { requireTenant } from './queryGuards';

export function useCharts(timeRange: TimeRange = '24h') {
  const { tenantId } = useTenant();

  return useQuery<ChartsResponse>({
    queryKey: ['charts', tenantId, timeRange],
    queryFn: () => {
      const requiredTenantId = requireTenant(tenantId);
      return apiClient.getCharts({ tenant_id: requiredTenantId, time_range: timeRange });
    },
    enabled: !!tenantId,
    refetchInterval: 60000, // Refresh every minute
  });
}
